/**
 * @license
 * Copyright Alibaba.com All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://github.com/NG-ZORRO/ng-zorro-antd/blob/master/LICENSE
 */

export default {
  // Options.jsx
  items_per_page: '/ rÃ»pel',
  jump_to: 'BiÃ§e',
  jump_to_confirm: 'piÅtrast bike',
  page: '',

  // Pagination.jsx
  prev_page: 'RÃ»pelÃª PÃªÅ',
  next_page: 'RÃ»pelÃª PaÅ',
  prev_5: '5 RÃ»pelÃªn PÃªÅ',
  next_5: '5 RÃ»pelÃªn PaÅ',
  prev_3: '3 RÃ»pelÃªn PÃªÅ',
  next_3: '3 RÃ»pelÃªn PaÅ'
};
